/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
// Entrypoint for babel polyfill.
import 'babel-polyfill';
import scroll from './src/utils/scroll';

exports.onRouteUpdate = ({location}) => {
  // If a hash exists, then scroll to the element corresponding to it.
  if (location.hash) {
    setTimeout(() => {
      const el = document.querySelector(`${location.hash}`);
      if (el) {
        scroll.scrollTo(el);
      }
    }, 1);
  }
  // If a hash doesn't exist, then the location corresponds to a new page. We
  // should handle these by scrolling to the top of the page.
  else {
    setTimeout(() => window.scrollTo(0, 0), 1);
  }
};

// Gatsby's default configuration preserves the scroll position for each
// component. This ends up feeling pretty wonky if we scroll down to 50% on one
// page, go to another page, and then go back to the first page -- Gatsby will
// return to the first page at the 50% scroll position, whereas we'd expect it
// to start at the top. We use a solution from:
// https://github.com/gatsbyjs/gatsby/issues/3249#issuecomment-360868222
exports.shouldUpdateScroll = (prevRouterProps, pathname) => {
  return false;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js